import { render } from "./AddManagerFeedbackPage.vue?vue&type=template&id=4e6b0f66&ts=true"
import script from "./AddManagerFeedbackPage.vue?vue&type=script&lang=ts"
export * from "./AddManagerFeedbackPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__